<div class="container">
    <div class="row">
        <div *ngIf="site.theme.logo" id="customer-site-not-found-header">
            <img [alt]="site.theme.logo.altText" [src]="site.theme.logo.url" />
        </div>
        <div id="customer-site-not-found-content">
            <div id="customer-site-not-found-content-404" [style.color]="themeColor">404</div>
            <div id="customer-site-not-found-content-msg">The page you are looking for cannot be found.</div>
            <a class="btn btn-lg btn-primary" [routerLink]="['']" [style.background-color]="themeColor">Visit careers site</a>
            <div id="customer-site-not-found-content-powered-by">powered by Snagajob.</div>
        </div>
    </div>
</div>
